import React, { useRef } from 'react'
import { BarChart, CartesianGrid, ResponsiveContainer } from 'recharts'

import { Bar, ChartTooltip, XAxis, YAxis } from '../../../Visualisation/components'
import { getAxisDomain, formatGraphData, getMonthlyInterval } from '../../../Visualisation/helpers'
import { GraphPayload } from '../../../Visualisation/types'
import { useBarChartHoverIndex } from '@src/containers/Visualisation'

type Props = {
  data?: GraphPayload
  graphHeight?: number
}

const ERChart: React.FC<Props> = ({ data, graphHeight }) => {
  const chartRef = useRef<any>(null)
  const [hoveredIndex, handleBarMouseMove, handleBarMouseLeave] = useBarChartHoverIndex()

  const formattedData = formatGraphData('er', undefined, data, value => Number(value).toFixed(1))
  const domain = getAxisDomain(formattedData, 'er')

  const monthlyInterval = getMonthlyInterval(13, data)

  return (
    <ResponsiveContainer width={'99%'} height={graphHeight}>
      <BarChart
        ref={chartRef}
        data={formattedData}
        barCategoryGap={3}
        maxBarSize={50}
        margin={{ top: 0, left: -15, right: 0, bottom: 0 }}
        onMouseMove={handleBarMouseMove}
        onMouseLeave={handleBarMouseLeave}
      >
        <defs>
          <linearGradient id="color-coverage" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#C3D0FD" />
            <stop offset="1" stopColor="#CDD8FE" />
          </linearGradient>
          <linearGradient id="colorHovered-coverage" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#6081FB" />
            <stop offset="1" stopColor="#7E99FC" />
          </linearGradient>
        </defs>
        {XAxis({ monthFormat: 'three', chartType: 'bar', barSize: 50, monthlyInterval })}
        {YAxis({ dataKey: 'er', unit: '%', domain })}
        <CartesianGrid stroke="#CED8FD" vertical={false} strokeDasharray="5 5" />
        {ChartTooltip({ cursor: false })}
        {Bar({
          dataKey: 'er',
          stroke: '#7E99FC',
          unit: '%',
          hoveredIndex,
          borderRadius: 15,
          graphData: formattedData,
          color: 'url(#color-coverage)',
          colorHovered: 'url(#colorHovered-coverage)'
        })}
      </BarChart>
    </ResponsiveContainer>
  )
}

export default ERChart
